import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { createElement } from "@wordpress/element";

/** @format */

/**
 * External dependencies
 */
import { Component } from '@wordpress/element';
import classnames from 'classnames';
import PropTypes from 'prop-types';
/**
 * Internal dependencies
 */

import EllipsisMenu from '../ellipsis-menu';
import { H } from '../section';
import { validateComponent } from '../lib/proptype-validator';
/**
 * A header component. The header can contain a title, actions via children, and an `EllipsisMenu` menu.
 */

var SectionHeader =
/*#__PURE__*/
function (_Component) {
  _inherits(SectionHeader, _Component);

  function SectionHeader() {
    _classCallCheck(this, SectionHeader);

    return _possibleConstructorReturn(this, _getPrototypeOf(SectionHeader).apply(this, arguments));
  }

  _createClass(SectionHeader, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          menu = _this$props.menu,
          title = _this$props.title;
      var className = classnames('woocommerce-section-header', this.props.className);
      return createElement("div", {
        className: className
      }, createElement(H, {
        className: "woocommerce-section-header__title woocommerce-section-header__header-item"
      }, title), createElement("hr", {
        role: "presentation"
      }), children && createElement("div", {
        className: "woocommerce-section-header__actions woocommerce-section-header__header-item"
      }, children), menu && createElement("div", {
        className: "woocommerce-section-header__menu woocommerce-section-header__header-item"
      }, menu));
    }
  }]);

  return SectionHeader;
}(Component);

SectionHeader.propTypes = {
  /**
   * Additional CSS classes.
   */
  className: PropTypes.string,

  /**
   * An `EllipsisMenu`, with filters used to control the content visible in this card
   */
  menu: validateComponent(EllipsisMenu),

  /**
   * The title to use for this card.
   */
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired
};
export default SectionHeader;
//# sourceMappingURL=index.js.map